import { atom } from 'recoil';

const questState = atom({
  key: 'questState',
  default: [
    {
        id: 0,
        quiz: '당신의 나라를 입력해주세요! (ex. The Republic of Korea)',
        value: 'The Republic of Korea'
    },
    {
        id: 1,
        quiz: '유토피아는 세계에서 가장 행복한 사람들이 사는 상상의 나라입니다. \n 현재 당신의 현실과 얼마나 비슷할까요? (1~100으로 입력해주세요)',
        value: 1
    },
    {
        id: 2,
        quiz: '당신이 예상하기에 당신은 몇 살까지 살수 있을까요 ? (0~100세)',
        value: 0
    },
    {
        id: 3,
        quiz: '당신의 평균 연봉을 입력해주세요! (만 원 단위, 최대 12억)',
        value: 0
    },
    {
        id: 4,
        quiz: '당신은 원하는 대로 결정을 내리고 행동 할 수 있다고 생각하시나요 ? ',
        value: 51
    },
    {
        id: 5,
        quiz: '당신은 자유로운 선택이 부담스럽다고 생각하시나요 ? ',
        value: 51
    },
    {
        id: 6,
        quiz: '선택지가 많아지면 사람들이 자유로워질것이라고 생각하시나요 ?',
        value: 51
    },
    {
        id: 7,
        quiz: '당신이 생각하기에 당신은 너그럽다고 생각하십니까 ? ',
        value: 51
    },
    {
        id: 8,
        quiz: '당신은 자연재해로 불우한 이웃을 위한 봉사를 하실 의향이 있으신가요 ?',
        value: 51
    },
    {
        id: 9,
        quiz: '당신이 월 300만원의 소득이 있다면 불우이웃을 위한 기부를 하실 의향이 있나요? ',
        value: 51
    },
    {
        id: 10,
        quiz: '당신은 기부나 봉사를 일주일에 한번 이상하시나요? \n(아주 작은 돈이거나 기부나 봉사 둘 중에 하나라도 하였다면 조금 맞는 것 같다. \n그 이상이라면 확실히 맞다.)',
        value: 51
    },
    {
        id: 11,
        quiz: '해당 질문에 대해서 자신의 생각을 솔직하게 체크해주세요.',
        value: 51
    },
    {
        id: 12,
        quiz: '해당 질문에 대해서 자신의 생각을 솔직하게 체크해주세요.',
        value: 51
    },
    {
        id: 13,
        quiz: '해당 질문에 대해서 자신의 생각을 솔직하게 체크해주세요.',
        value: 51
    },
    {
        id: 14,
        quiz: '해당 질문에 대해서 자신의 생각을 솔직하게 체크해주세요.',
        value: 51
    },
    {
        id: 15,
        quiz: '해당 질문에 대해서 자신의 생각을 솔직하게 체크해주세요.',
        value: 51
    },
    {
        id: 16,
        quiz: '해당 질문에 대해서 자신의 생각을 솔직하게 체크해주세요.',
        value: 51
    },
    {
        id: 17,
        quiz: '당신이 고민하는 일이 있을 때 진심어린 조언을 해줄 사람이 있습니까? ',
        value: 51
    },
    {
        id: 18,
        quiz: '함께 즐거운 시간을 보낼 혹은 언제든지 연락할 수 있는 친구가 있습니까?  ',
        value: 51
    },
    {
        id: 19,
        quiz: '사소한 말이라도 당신의 말을 귀기울여 들어주거나 관심이 있는 사람이 있습니까? ',
        value: 51
    },
    {
        id: 20,
        quiz: '곤경에 처했을 때 도움을 줄 수 있는 친척이나 가족이 있습니까? ',
        value: 51
    },
    {
        id: 21,
        quiz: '식사를 직접 할 수 없는 경우 대신 식사를 준비해줄 사람이 있습니까 ? ',
        value: 51
    },
    {
        id: 22,
        quiz: '학교나 직장에서 어려움을 겪을 때 의논할 사람이 있습니까 ?  ',
        value: 51
    },
    {
        id: 23,
        quiz: '말하기 어려운 사적인 이야기를 털어놓을 수 있는 사람이 있습니까 ? ',
        value: 51
    },
    {
        id: 24,
        quiz: '당신에게 사랑과 애정을 보여주는 사람이 있습니까?',
        value: 51
    },
    {
        id: 25,
        quiz: '사랑과 애정을 보여줄 수 있는 사람이 있습니까?',
        value: 51
    },
    ] 
});

const currentNumState = atom({
    key: 'currentNumState',
    default: 0
});

export { questState, currentNumState };
